export default {
      id: "logo-usage",
      viewBox: "0 0 154 56",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#logo",
      toString: function () {
        return this.url;
      }
    }